<template>
  <div v-if="formRuntimeDialog.visible">
    <div ref="dialogFormRuntime" class="dialog-form-runtime" v-show="formRuntimeDialog.visible">
      <div :class="formRuntimeDialog.width">
          <div class="diglog-form-title">
            {{formRuntimeDialog.title}}
            <span class="close" @click="closeDIalogWithX">X</span>
            <div class="line"></div>
          </div>
          <form-runtime v-if="formRuntimeDialog.visible&&formRuntimeDialog.type==='form'" :id="formRuntimeDialog.id"
          :isDialog="true"
          :dialogTitle='formRuntimeDialog.title'
          :dialogWidth="formRuntimeDialog.width"
          :dialogDisabled="formRuntimeDialog.disabled"
          :dialogDataId="formRuntimeDialog.dataId"
          :formValidates="formRuntimeDialog.formValidates"
          :interactions="formRuntimeDialog.interactions"
          :tableEdit="formRuntimeDialog.tableEdit"
          :compareField="formRuntimeDialog.compareField"
          :passFieldList="formRuntimeDialog.passFieldList"
          :openType="formRuntimeDialog.openType"
          @closeDialog="getCloseDialog"
          @goSearch="goSearch"></form-runtime>
           <process-runtime v-if="formRuntimeDialog.visible&&formRuntimeDialog.type==='process'"
          :definitionId="formRuntimeDialog.id"
          :dialogWidth="formRuntimeDialog.width"
          :dialogDisabled="formRuntimeDialog.disabled"
          :dialogDataId="formRuntimeDialog.dataId"
          :dialogTaskId="formRuntimeDialog.taskId"
          :formRuntimeDialog="formRuntimeDialog"
          @closeDialog="getCloseDialog"></process-runtime>
          <process-view v-if="formRuntimeDialog.visible&&formRuntimeDialog.type==='process-view'"
          :dialogInstanceId="formRuntimeDialog.instanceId"
          :currentstateNodeId="formRuntimeDialog.currentNodeId"
          :nodeId="formRuntimeDialog.nodeId"
          :dialogWidth="formRuntimeDialog.width"
          :isFromDoingTasks="formRuntimeDialog.isFromDoingTasks"
          :comeFrom="formRuntimeDialog.comeFrom"
          @closeDialog="getCloseDialog"></process-view>
      </div>
    </div>
    <div class="modal" v-show="formRuntimeDialog.visible"></div>
  </div>
</template>

<script>
import FormRuntime from '@/components/form/runtime/form-runtime.vue'
import ProcessRuntime from '@/components/process/runtime/process-runtime.vue'
import ProcessView from '@/components/process/runtime/process-view.vue'
export default {
  name: 'DialogFormRuntime',
  props: ['formRuntimeDialog'],
  provide () {
    return {
      formArgs: {formType: ''}
    }
  },
  components: {
    FormRuntime,
    ProcessRuntime,
    ProcessView
  },
  watch: {
    'formRuntimeDialog.title' (val) {
      if (val) {
        this._provided.formArgs.formType = val
      }
    }
  },
  methods: {
    getCloseDialog (type) {
      this.formRuntimeDialog.visible = false
      // 当在报表执行页的按钮操作结束时,需要对当前页面的数据进行刷新
      if ((type === 'comfirm' || type === 'custom') && ['report-design-list', 'report-runtime', 'huaao'].some(n => location.href.includes(n))) {
        this.$emit('goSearch')
      } else if (type === 'process' && ['report-design-list', 'report-runtime', 'process-doingTasks', '/'].some(n => location.href.includes(n))) {
        this.$emit('goSearch')
      } else if (type === 'process-view') {
        //  状态中的查看需要重新唤起弹窗
        this.$emit('openDialog')
      } else if (type === 'process-instance-edit') {
        // 刷新流程实例列表
        this.$emit('getTableData')
      }
    },
    goSearch () {
      this.$emit('goSearch')
    },
    closeDIalogWithX () {
      let type = this.formRuntimeDialog.type
      if (type === 'form') {
        type = 'comfirm'
      }
      this.getCloseDialog(type)
    }
  }
}
</script>
<style lang="scss" >
.modal {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .5;
  background: #000;
  z-index: 200;
}

.dialog-form-runtime {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 201;
  border: 1px solid #E6E6E6;
  border-top: none;

  >div {
    width: 100%;
    height: calc(100% - 34px);

    &.full{
       width: 100%;
       height: calc(100% - 34px);
    }
    &.middle {
      width: 800px;
      height: 600px;
      margin:8vh auto 0;

    }
    &.small {
      width: 600px;
      height: 400px;
      margin: 12vh auto 0;
    }
    .diglog-form-title{
      position: relative;
      text-align: center;
      height: 34px;
      line-height: 34px;
      background: #fff;
      top:0;
      .line {
        width: 98%;
        height: 1px;
        background: #EDEEEE;
        position: absolute;
        bottom: 1px;
        left: 0.86%;
      }

      .close {
        position: absolute;
        right: 20px;
        top: 0;
        cursor: pointer;
        z-index: 201;
        color: #ADAFB0;
        &:hover {
          color: red;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/dialog-form-runtime.vue